import React, {useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    CardText,
    Col,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Spinner
} from "reactstrap";
import { deleteUserAction, editAction, setOpenModal } from '../../store';
import {useDropzone} from "react-dropzone";
import { DownloadCloud, FileText, X } from 'react-feather';
import toast from 'react-hot-toast';

//import toast from "react-hot-toast";
//import axios from "axios";

const AddLogo = () => {
    const dispatch = useDispatch()
    const { modal } = useSelector(state => state.businessManager)
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [businessLogo, setBusinessLogo] = useState(false);
    const { data } = useSelector((state) => state.businessManager)
    
    const handleDelete = async () => {

        setLoading(true);
        await dispatch(deleteUserAction(modal.delete.data));
        handleClose(false);

        setLoading(false);

    }

    const handleClose = () => {
        dispatch(setOpenModal({ open: false }))
    }

    const { getRootProps, getInputProps } = useDropzone({
        multiple: false,
        accept: {
            'application/msword': ['.png', '.jpeg']
        },
        onDrop: (acceptedFiles, rejectedFiles) => {
            if (rejectedFiles.length) {
                toast.error('Solo se pueden cargar archivos en formato word!.')
            } else {
                setFiles([...files, ...acceptedFiles.map(file => Object.assign(file))])
            }
        }
    })

    const renderFilePreview = file => {
        if (file.type.startsWith('image')) {
            //setBusinessLogo(URL.createObjectURL(file))
            return <img className='rounded' alt={file.name} src={URL.createObjectURL(file)} height='28' width='28' />
        } else {
            return <FileText size='28' />
        }
    }

    const handleRemoveFile = file => {
        const filtered = files.filter(i => i.name !== file.name)
        setFiles([...filtered])
    }

    const renderFileSize = size => {
        if (Math.round(size / 100) / 10 > 1000) {
            return `${(Math.round(size / 100) / 10000).toFixed(1)} mb`
        } else {
            return `${(Math.round(size / 100) / 10).toFixed(1)} kb`
        }
    }

    const fileList = files.map((file, index) => (
        <ListGroupItem key={`${file.name}-${index}`} className='d-flex align-items-center justify-content-between'>
            <div className='file-details d-flex align-items-center'>
                <div className='file-preview me-1'>{renderFilePreview(file)}</div>
                <div>
                    <p className='file-name mb-0'>{file.name}</p>
                    <p className='file-size mb-0'>{renderFileSize(file.size)}</p>
                </div>
            </div>
            <Button color='danger' outline size='sm' className='btn-icon' onClick={() => handleRemoveFile(file)}>
                <X size={14} />
            </Button>
        </ListGroupItem>
    ))

    const handleRemoveAllFiles = () => {
        setFiles([])
    }

    const handleAddLogo = () => {
        dispatch(editAction({...data, logo: URL.createObjectURL(files[0])}))
        handleClose(false)
        toast.success("¡El logo se ha actualizado correctamente!")
        //console.log("files: ", URL.createObjectURL(files[0]) )
        //console.log("URL: ", URL.createObjectURL(file))
    }
    const uploadTemplate = async () => {
        const requestsUploadTemplates = [];
        for (const file of files) {
            const formData = new FormData();
            formData.append("template", file)
            requestsUploadTemplates.push(axios.post(`${process.env.REACT_APP_API_NODE_URL}/upload/template/crediq`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }))
        }
        toast.success('Plantilla cargada con exito!')
        return await Promise.all(requestsUploadTemplates);
    }

    return (
        <Modal isOpen={modal.logo?.open} toggle={() => handleClose(false)} className='modal-dialog-centered modal-lg'>
            <ModalHeader className='bg-transparent' toggle={() => handleClose(false)}></ModalHeader>
            <ModalBody className='px-sm-5 mx-50 pb-5'>
                <div className='text-center mb-2'>
                    <h1 className='mb-1'>Añadir logo</h1>
                </div>
                {loading ? <Row>
                    <div className='col-12 px-2 py-4 text-center'>
                        <Spinner size='lg'/>
                        <CardText className={'py-1 fs-5'}>Eliminando registro...</CardText>
                    </div>
                </Row> : <Row className='gy-1 pt-75'>
                    <Col md={12} xs={12} className={'text-center'}>
                        <p>Suba su logo para poder agregarlo a los documentos que se emitirán</p>
                    </Col>
                    {files.length === 0 && <Col md={12} xs={12} className={'pt-1 px-3'}><Row {...getRootProps({ className: 'dropzone' })}>
                        <input {...getInputProps()} />
                        <div className='d-flex align-items-center justify-content-center flex-column'>
                            <DownloadCloud size={64} />
                            <h5>Arrastra un archivo aqui (.PNG, .JPEG) para cargar</h5>
                            <p className='text-secondary'>
                                o click en {' '}
                                <a href='/' onClick={e => e.preventDefault()}>
                                    seleccionar un archivo
                                </a>{' '}
                                desde tu dispositivo
                            </p>
                        </div>
                    </Row></Col>}

                    {files.length > 0 && (
                        <Col md={12} xs={12}>
                            <ListGroup className='my-2'>{fileList}</ListGroup>
                        </Col>
                    )}
                    <Col xs={12} className='text-center mt-2 pt-50'>
                        <Button type='button'
                                onClick={handleRemoveAllFiles}
                                className='me-1' color='danger' /*disabled={!item}*/>
                            Remover
                        </Button>
                        <Button type='reset' color='secondary' outline onClick={() => handleAddLogo()}>
                            Cargar logo
                        </Button>
                    </Col>
                </Row>}

            </ModalBody>
        </Modal>
    );
};

export default AddLogo;
